import { createContext, useContext, type ReactNode } from "react";

import type { AdministratorAuthenticationBoundary } from "./auth-session";

export type AdministratorAuthenticationContextValue = Readonly<{
  authentication: AdministratorAuthenticationBoundary;
  signIn: (() => Promise<void>) | null;
  signOut: (() => Promise<void>) | null;
}>;

const Context = createContext<AdministratorAuthenticationContextValue | null>(null);

export function AdministratorAuthenticationProvider({
  children,
  value,
}: Readonly<{
  children: ReactNode;
  value: AdministratorAuthenticationContextValue;
}>): React.JSX.Element {
  return <Context.Provider value={value}>{children}</Context.Provider>;
}

export function useAdministratorAuthentication(): AdministratorAuthenticationContextValue {
  const value = useContext(Context);
  if (value === null) throw new Error("Administrator authentication provider is missing.");
  return value;
}
